import React from 'react';
import { Dialog, Image, T, useTranslation } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
import IconRankBronze from '@static/images/ranking_divisions/bronze.svg';
import IconRankSilver from '@static/images/ranking_divisions/silver.svg';
import IconRankGold from '@static/images/ranking_divisions/gold.svg';
import IconRankPlatinum from '@static/images/ranking_divisions/platinum.svg';
import IconRankDiamond from '@static/images/ranking_divisions/diamond.svg';
import styles from './RankedGamesDescriptionDialog.module.scss';
export const RankedGamesDescriptionDialog = ({ open, onClose, onLearnMoreClick })=>{
    const DECORATIVE = emptyTranslation;
    const { tArray } = useTranslation();
    const howItWorksBullets = tArray('strings:homePage.ranked.infoPopup.howItWorks.description');
    const gameSettingsBullets = tArray('strings:homePage.ranked.infoPopup.gameSettings.description');
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.ranked.infoPopup.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.iconsRow
    }, /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: IconRankBronze,
            alt: DECORATIVE
        }
    }), /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: IconRankSilver,
            alt: DECORATIVE
        }
    }), /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: IconRankGold,
            alt: DECORATIVE
        }
    }), /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: IconRankPlatinum,
            alt: DECORATIVE
        }
    }), /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: IconRankDiamond,
            alt: DECORATIVE
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.textsContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.textsWrapper
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.textSection
    }, /*#__PURE__*/ React.createElement("h3", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.ranked.infoPopup.howItWorks.title'
        }
    })), /*#__PURE__*/ React.createElement("ul", null, howItWorksBullets.map((bullet, i)=>/*#__PURE__*/ React.createElement("li", {
            key: i
        }, bullet)))), /*#__PURE__*/ React.createElement("div", {
        className: styles.textSection
    }, /*#__PURE__*/ React.createElement("h3", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.ranked.infoPopup.gameSettings.title'
        }
    })), /*#__PURE__*/ React.createElement("ul", null, gameSettingsBullets.map((bullet, i)=>/*#__PURE__*/ React.createElement("li", {
            key: i
        }, bullet))))))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.CancelButton, {
        onClick: onLearnMoreClick
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.ranked.infoPopup.learnMore'
        }
    }))));
};
